import { Route, Routes } from "react-router-dom";
import Home from "components/Home";
import Header from "components/Header";
import Footer from "./Footer";
import Layout from "antd/es/layout/layout";
import ContactUs from "./ContactUs";
import AboutUs from "./AboutUs";
import Dvt from "./OurServices/DVT";
import ProdRed from "./OurServices/ProdRed";
import MarketPulse from "./OurServices/MarketPulse";

const App = () => {
  return (
    <Layout className="vh100">
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/aboutUs" element={<AboutUs />} />
        <Route exact path="/ourServices">
          <Route exact path="dvt" element={<Dvt />} />
          <Route exact path="prodRed" element={<ProdRed />} />
          <Route exact path="marketPulse" element={<MarketPulse />} />
        </Route>
        <Route exact path="/contactUs" element={<ContactUs />} />
      </Routes>
      <Footer />
    </Layout>
  );
};
export default App;
